import dynamic from 'next/dynamic';

import { ConfigPublic } from '@/common/config.public';
import { getGitBranch, getGitClosestTag } from '@/common/server/showGitInfo';
import { elysiumLogger } from '@/common/utils/sharedUtils';

import styles from './GitInfoComponent.module.scss';

export interface GitInfo {
  bfwVersion: string;
  bfwBranch: string;
  bfwClosestTag: string;
  bfwClosestTagCount: string;
  elysiumVersion: string;
  elysiumBranch: string;
  elysiumClosestTag: string;
}

export interface GitInfoProps {
  git: GitInfo | null;
}

const path = `/elysium-api/general/v1/ping`;
const version: string = ConfigPublic.BuildVersion;

export const getGitVersion = async (): Promise<GitInfo | null> => {
  try {
    const url = new URL(path, ConfigPublic.AppUrl);
    const response = await fetch(url);
    return parsePingResponse(response);
  } catch (error) {
    elysiumLogger().error('Failed to fetch git version', error);
    return null;
  }
};

const parsePingResponse = (response: Response): GitInfo => {
  const headers = response.headers;

  return {
    bfwVersion: headers.get('bfw-version') ?? 'N/A',
    bfwBranch: headers.get('bfw-branch') ?? 'N/A',
    bfwClosestTag: headers.get('bfw-closest-tag') ?? 'N/A',
    bfwClosestTagCount: headers.get('bfw-closest-tag-count') ?? 'N/A',
    elysiumVersion: version || 'N/A',
    elysiumBranch: getGitBranch(),
    elysiumClosestTag: getGitClosestTag(),
  };
};

export const GitInfo = ({ git }: GitInfoProps) => {
  return (
    <div className={styles.gitInfo}>
      <p>
        <strong>BFW version: </strong>
        {git?.bfwVersion}
      </p>
      <p>
        <strong>BFW branch: </strong>
        {git?.bfwBranch}
      </p>
      <p>
        <strong>BFW closest tag: </strong>
        {git?.bfwClosestTag}
      </p>
      <p>
        <strong>BFW closest tag count: </strong>
        {git?.bfwClosestTagCount}
      </p>
      <p>
        <strong>Elysium version: </strong>
        {git?.elysiumVersion}
      </p>
      <p>
        <strong>Elysium branch: </strong>
        {git?.elysiumBranch}
      </p>
      <p>
        <strong>Elysium closest tag: </strong>
        {git?.elysiumClosestTag}
      </p>
    </div>
  );
};

export const DynamicGitInfo = dynamic(
  () => import('@/common/utils/git/GitInfo').then((module) => module.GitInfo),
  { ssr: false },
);

export default DynamicGitInfo;
